import * as React from "react";
import Cell from "source/app/presentation/MainPanel/Dreams/Cell/Cell";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DisplayWinningStreak({
    goodStreakLength,
    badStreakLength,
    maxGoodStreakLength,
}: {
    goodStreakLength?: number;
    badStreakLength?: number;
    maxGoodStreakLength: number;
}) {
    if (badStreakLength && badStreakLength > 0) {
        return null;
    }

    // Show an empty streak chain if both good and bad streak lenghts are zero
    if (goodStreakLength === undefined) {
        goodStreakLength = 0;
    }

    const styleClass = StyleClass(`streakLength_${goodStreakLength}`, {
        fontSize: `15px`,
        opacity:
            1 - (Math.min(7, maxGoodStreakLength) + 1 - goodStreakLength) / 10,
        color:
            goodStreakLength && goodStreakLength >= maxGoodStreakLength
                ? `coral`
                : `yellowgreen`,
        textShadow: goodStreakLength
            ? `0px 0px ${goodStreakLength * 2}px gold`
            : `none`,
    });

    const streakText = `+${goodStreakLength}`;

    return <Cell classes={styleClass}>{streakText}</Cell>;
}
